// Manual for the Study Definition and Data Migration admin views, reachable from both toolbars.
export default [
    {
        displayName: "Anleitung (PDF)",
        fileName: "StudyDefinition_and_DataMigrations_Guide.pdf",
        link: require("@/assets/documents/StudyDefinition_and_DataMigrations_Guide.pdf")
    }
];
